import { createAction, props } from '@ngrx/store';

import { SearchResult, SearchResultsCounts } from './data-access-search.models';

import { SearchFilters, SearchSortOrder, SearchType } from '../../model/search-filter';
import { SearchAutocompleteSuggestion } from '../../service/search-api-response.models';
import { StringFilter } from '../option-ids-visible/search-filter-options.models';
import { SearchFilterOptionsEntity } from '../option-ids-visible/search-filter-options.models';

export const searchPageOpened = createAction('[Search Page] Search page opened', props<{ filters: SearchFilters }>());
export const searchPageClosed = createAction('[Search Page] Search page closed');

export const loadSearchResults = createAction('[Search Page] Search Results Load', props<{ filters: SearchFilters }>());

export const searchResultsLoadSucceeded = createAction(
  '[Search Service] Search Results Load Success',
  props<{
    counts: SearchResultsCounts;
    results: SearchResult[];
    filterOptions: SearchFilterOptionsEntity[];
    requestedFilters: SearchFilters;
  }>()
);

export const searchResultsLoadFailed = createAction(
  '[Search Service] Search Results Load Failed',
  props<{ error: string }>()
);

export const searchFiltersLoadAfterUncheckSucceeded = createAction(
  '[Search Service] Search Filters after uncheck Load Success',
  props<{
    counts: SearchResultsCounts;
    results: SearchResult[];
    filterOptions: SearchFilterOptionsEntity[];
    requestedFilters: SearchFilters;
  }>()
);

export const searchFiltersLoadAfterUncheckFailed = createAction(
  '[Search Service] Search Filters after uncheck Load Failed',
  props<{ error: string }>()
);

export const searchCountsLoadSucceeded = createAction(
  '[Search Service] Search Counts Load Success',
  props<{ counts: SearchResultsCounts }>()
);

export const searchCountsLoadFailed = createAction(
  '[Search Service] Search Counts Load Failed',
  props<{ error: string }>()
);

export const searchFilterModalOpened = createAction('[Search Filter Modal] Filter modal opened');
export const searchFilterModalClosed = createAction('[Search Filter Modal] Filter modal closed');

export const searchTypeSelected = createAction(
  '[Search Page] Search type selected',
  props<{ searchTypes: SearchType[] }>()
);

export const searchTermSelected = createAction('[Search Page] Search term selected', props<{ searchTerm: string }>());

export const stringFilterChanged = createAction(
  '[Search Service] String filter changed',
  props<{ stringFilter: StringFilter }>()
);

export const searchPaginationClicked = createAction(
  '[Search Page] Search pagination clicked',
  props<{ searchPageIndex: number }>()
);

export const searchSortingSelected = createAction(
  '[Search Page] Search sorting selected',
  props<{ searchSortOrder: SearchSortOrder }>()
);

export const searchFormValueChanged = createAction(
  '[Search Page] Search term form value changed',
  props<{ searchTermFragment: string | null }>()
);
export const searchTermAutocompleteLoadSucceeded = createAction(
  '[Search Page] Search term autocomplete load succeeded',
  props<{ suggestions: SearchAutocompleteSuggestion[] }>()
);
export const searchTermAutocompleteLoadFailed = createAction(
  '[Search Page] Search term autocomplete load failed',
  props<{ error: string }>()
);

export const searchFormValueIsInvalid = createAction('[Search Page] Search term form value is invalid');

export const loadSearchTermSuggestions = createAction(
  '[Search Page] Load search term suggestions',
  props<{ filters: SearchFilters }>()
);

export const searchTermSuggestionsLoadSucceeded = createAction(
  '[Search Page] Search term suggestions load succeeded',
  props<{ suggestions: string[] }>()
);

export const searchTermSuggestionsLoadFailed = createAction(
  '[Search Page] Search term suggestions load failed',
  props<{ error: string }>()
);

export const useSuggestedSearchTerm = createAction(
  '[Search Page] Load Search Results with suggested search term',
  props<{ suggestedSearchTerm: string }>()
);

export const loadSearchResultsSuggestions = createAction('[Search Page] Load search result suggestions');
export const searchResultSuggestionsLoadSucceeded = createAction(
  '[Search Page] Search result suggestions load succeeded',
  props<{
    resultSuggestions: SearchResult[];
  }>()
);
export const searchResultSuggestionsLoadFailed = createAction(
  '[Search Page] Search result suggestions load failed',
  props<{ error: string }>()
);

export const generateSearchDocument = createAction('[Search/API] Generate Search Document');

export const generateSearchDocumentSuccess = createAction(
  '[Search/API] Generate document Success',
  props<{ documentId: string }>()
);

export const generateSearchDocumentFailure = createAction('[Search/API] Generate document Failure');
